import apiClient from '@api/apiClient';

const getMe = async () => {
  try {
    const response = await apiClient.get('users/me', {
      middleware: {withAuth: true},
    });
    const {data} = response || {};
    return data;
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const updateProfile = async ({username, email, avatarFile} = {}) => {
  try {
    const formData = new FormData();
    if (username !== undefined) formData.append('username', username);
    if (email !== undefined) formData.append('email', email);
    if (avatarFile) {
      try {
        formData.append('avatar_file', avatarFile, avatarFile.name);
      } catch (e) {
        console.log(e);
        formData.append('avatar_file', avatarFile);
      }
    }
    if ([...formData.keys()].length === 0) return {};

    const response = await apiClient.put(`profile`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      middleware: {withAuth: true},
    });
    const {data} = response || {};
    return data;
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const updatePassword = async ({last_password, new_password} = {}) => {
  try {
    const response = await apiClient.put(
      `profile/password`,
      {last_password, new_password},
      {
        middleware: {withAuth: true},
      },
    );
    const {data} = response || {};
    return data ?? {};
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

export const profileAPI = {
  getMe,
  updateProfile,
  updatePassword,
};
